import { Component } from '@angular/core'

@Component({
    selector: 'app-youtube-link-icon',
    templateUrl: './youtube-link-icon.component.html',
    styleUrls: ['./youtube-link-icon.component.css'],
    standalone: true,
})
export class YoutubeLinkIconComponent {}
